module.exports = __webpack_public_path__ + "img/cash-tip.d0980ad6.svg";